import APIHelper from "../common/ApiHelper";
import APIURLConstants from "../common/ApiURLConstants";
import { handleError, authHeader, Role } from "../helper";
import jwt_decode from "jwt-decode";
import { BallotDashboardService } from "./ballotDashboard.Service";

export const UserDataService = {
  getAllApplicationUsers,
  //getUserProfile,
  //getLoggedInUserDetails,
  getPlayerProfileDisplayFlag,
  getActiveEventId,
  getStorageAccessEnumerationConfigData,
  getPlayerFileDetails,
  getUserPermissionDetails,
  getUserEmail,
  getUserRole,
  isUserLoggedIn,
  getCombineResultsDisplayFlag,
  redirectToTeamDashboard,
  getGameAuditRefreshTimeToken,
};

function getAllApplicationUsers() {
  return APIHelper.get(APIURLConstants.GET_ALL_APPLICATION_USERS, authHeader())
    .then((result) => {
      return result.data;
    })
    .catch(handleError);
}

// function getUserProfile(loginId) {
//   return APIHelper.get(
//     `${APIURLConstants.GET_USER_PROFILE}?windowsId=${loginId}`,
//     authHeader()
//   )
//     .then((result) => {
//       return result.data;
//     })
//     .catch(handleError);
// }

// function getLoggedInUserDetails() {
//   return APIHelper.get(APIURLConstants.GET_LOGGEDIN_USER_DETAILS)
//     .then((result) => {
//       return result.data;
//     })
//     .catch(handleError);
// }

function getPlayerProfileDisplayFlag() {
  return APIHelper.get(
    APIURLConstants.GET_PLAYER_PROFILE_DISPLAY_FLAG,
    authHeader()
  )
    .then((result) => {
      return result.data;
    })
    .catch(handleError);
}

function getActiveEventId() {
  return APIHelper.get(
    APIURLConstants.GET_ACTIVE_COMBINECENTRAL_EVENT_ID,
    authHeader()
  )
    .then((result) => {
      return result.data;
    })
    .catch((err) => {
      console.log(err);
    });
}

function getStorageAccessEnumerationConfigData() {
  return APIHelper.get(
    APIURLConstants.GET_STORAGE_ACCESS_ENUMERATION_CONFIG,
    authHeader()
  )
    .then((result) => {
      return result;
    })
    .catch(handleError);
}

function getPlayerFileDetails(eventId, playerId, userBy) {
  return APIHelper.get(
    `${APIURLConstants.GET_PLAYER_FILE_DETAILS}/${eventId}/${playerId}`,
    authHeader()
  )
    .then((result) => {
      return result;
    })
    .catch(handleError);
}

function isUserLoggedIn() {
  let jwt = sessionStorage.getItem("accessToken");
  if (jwt) {
    return true;
  }
  return false;
}

function getUserRole() {
  let jwt = sessionStorage.getItem("accessToken");
  if (jwt) {
    const currentUser = jwt_decode(jwt);
    return currentUser.role ? currentUser.role : "";
  }
  return "";
}

function getUserEmail() {
  let jwt = sessionStorage.getItem("accessToken");
  if (jwt) {
    const currentUser = jwt_decode(jwt);
    const email = currentUser.email
      ? currentUser.email
      : currentUser.unique_name
      ? currentUser.unique_name
      : currentUser.preferred_username
      ? currentUser.preferred_username
      : "";
    //console.log("Get User Email", email);
    return email;
  }
  return "";
}

function getUserPermissionDetails(email) {
  return APIHelper.get(
    `${APIURLConstants.GET_USER_PERMISSION_DETAILS}/${email}`,
    authHeader()
  )
    .then((result) => {
      return result.data;
    })
    .catch(handleError);
}

function getCombineResultsDisplayFlag() {
  return APIHelper.get(
    APIURLConstants.GET_COMBINE_RESULTS_DISPLAY_FLAG,
    authHeader()
  )
    .then((result) => {
      return result.data;
    })
    .catch(handleError);
}

function redirectToTeamDashboard() {
  return new Promise((resolve) => {
    sessionStorage.setItem("checkUserAndNavigation", "false");
    let userEmail = getUserEmail();
    if (userEmail !== "") {
      getUserPermissionDetails(userEmail).then((userProfile) => {
        if (
          userProfile &&
          userProfile.appRoles &&
          !userProfile.appRoles.includes(Role.CombineBallotUser)
        ) {
          sessionStorage.setItem("checkUserAndNavigation", "false");
          resolve(false);
        } else {
          BallotDashboardService.getTeamBallotDashboardFlagForTeamUser().then(
            (teamBallotDashboardDBFlag) => {
              if (
                teamBallotDashboardDBFlag &&
                teamBallotDashboardDBFlag[0].childName === "true"
              ) {
                sessionStorage.setItem("checkUserAndNavigation", "false");
                resolve(true);
              } else {
                sessionStorage.setItem("checkUserAndNavigation", "false");
                resolve(false);
              }
            }
          );
        }
      });
    } else resolve(false);
  });
}

function getGameAuditRefreshTimeToken() {
  return APIHelper.get(
    APIURLConstants.GET_GAME_AUDIT_REFRESH_TIME_FLAG,
    authHeader()
  )
    .then((result) => {
      return result.data;
    })
    .catch(handleError);
}
